import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: (projectName: string) => string | React.ReactNode;
    description: string;
    installInstead: (onOpenAppDownload: () => void) => string | React.ReactNode;
    downloadAppsInstead: string;
    cancel: string;
};
export type Deps = {
    InlineButton: any;
};
export default {
    DEFINE(_messages: Text, { InlineButton }: Deps): void {
        return Object.defineProperties(this, {
            /** Dialog title for the mount project flow */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (projectName: string) => __intl__.intl().formatMessage({ id: "OpenOnDesktopDialogContent.title?c=2svluue417y71", defaultMessage: "Open {projectName} on desktop..." }, { projectName: projectName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Short description in the first step */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OpenOnDesktopDialogContent.description?c=2atpvvbagkwp4", defaultMessage: "The Frame.io Drive App is required to open projects locally." }));
                },
                enumerable: true,
                configurable: true
            },
            installInstead: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (onOpenAppDownload: () => void) => __intl__.intl().formatMessage({ id: "OpenOnDesktopDialogContent.installInstead?c=1xq9ju01rb33j", defaultMessage: "<jsx>Need to Install? <InlineButton>Download App</InlineButton></jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), InlineButton: (__children__: React.ReactNode) => <InlineButton onClick={onOpenAppDownload} variant="primary">{React.Children.toArray(__children__)}</InlineButton> }));
                },
                enumerable: true,
                configurable: true
            },
            /** Inline CTA to switch to app download dialog */
            downloadAppsInstead: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OpenOnDesktopDialogContent.downloadAppsInstead?c=1fef78szzejv9", defaultMessage: "Download apps instead" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dismiss button */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "OpenOnDesktopDialogContent.cancel?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
